import { render, staticRenderFns } from "./AddOnCard.vue?vue&type=template&id=b7dcb3b6&scoped=true&"
import script from "./AddOnCard.vue?vue&type=script&lang=ts&"
export * from "./AddOnCard.vue?vue&type=script&lang=ts&"
import style0 from "./AddOnCard.vue?vue&type=style&index=0&id=b7dcb3b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dcb3b6",
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtn})
